import FriendRequestPage from "./FriendRequestPage";
export default FriendRequestPage;
